import {
  ICustomField,
  ICustomFieldDTO,
} from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

/**
 * Transforms a custom field object to its DTO representation for API communication.
 *
 * @param field - The custom field object to transform
 * @returns The transformed custom field DTO ready for API submission
 */
export const transformCustomFieldToDTO = (
  field: ICustomField
): ICustomFieldDTO => {
  const { id, isNew, choices, ...restField } = field;

  return {
    ...(id && !isNew ? { customFieldId: id } : {}), // Map id to customFieldId for existing fields
    ...restField,
    choices: choices?.map((choice) => choice.value) || undefined,
  };
};

/**
 * Transforms custom field DTOs from the API into the application's internal representation.
 *
 * @param fieldDTO - Array of custom field DTOs received from the API, or undefined if no data is available
 * @returns Array of custom field objects ready for use in the application. Returns an empty array if input is undefined.
 */
export const transformCustomFieldFromDTO = (
  fieldDTO: ICustomFieldDTO[] | undefined
): ICustomField[] => {
  if (!fieldDTO) {
    return [];
  }

  return fieldDTO.map((field) => {
    const { customFieldId, choices, ...restField } = field;

    return {
      id: customFieldId!,
      ...restField,
      choices:
        choices?.map((value) => ({
          id: crypto.randomUUID(),
          value,
        })) || undefined,
    };
  });
};
